import { Component, Inject } from '@angular/core';
import { NgIf, ViewportScroller } from '@angular/common';
import { Router } from '@angular/router';
import { MatRippleModule } from '@angular/material/core';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'iho-plp-refresh-alert',
  standalone: true,
  imports: [MatRippleModule, MatDialogModule, NgIf],
  templateUrl: './plp-refresh-alert.component.html',
  styleUrls: ['./plp-refresh-alert.component.scss'],
})
export class PlpRefreshAlertComponent {
  pageType = 'جستجو'

  constructor(
    @Inject(MAT_DIALOG_DATA) data: { pageType: string },
    private readonly router: Router,
    private readonly viewportScroller: ViewportScroller,
    private readonly dialogRef: MatDialogRef<PlpRefreshAlertComponent>,
  ) {
    this.pageType = data.pageType ?? 'plp'
  }

  goToHome(): void {
    this.dialogRef.afterClosed().subscribe(() => {
      void this.router.navigateByUrl('/').then((navigated) => {
        if (!navigated) return;

        setTimeout(() => this.viewportScroller.scrollToPosition([0, 0]));
      });
    });

    this.dialogRef.close();
  }
}
